export default 'sudo gem install jwt';
